/**
 * Created by Mr.xie on 2021/11/25 9:59.
 */
import { ImagePreview } from 'vant';
export default {
  methods: {
    onImagePreview (images, index) {
      ImagePreview({
        images: images,
        startPosition: index
      });
    }
  }
};